import { inject, Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RootService {
  static Injector?: Injector;

  private injector = inject(Injector);

  constructor() {
    RootService.Injector = this.injector;
  }
}
